var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GatewayGamesMain',{attrs:{"title":"Live Casino","category":"live_casino"}})
}
var staticRenderFns = []

export { render, staticRenderFns }